var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V11.08C21 11.6323 20.5523 12.08 20 12.08C19.4477 12.08 19 11.6323 19 11.08V9H14C13.4477 9 13 8.55228 13 8V3H6C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4V20C5 20.5477 5.45228 21 6 21H12C12.5523 21 13 21.4477 13 22C13 22.5523 12.5523 23 12 23H6C4.34772 23 3 21.6523 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM15 4.41421L17.5858 7H15V4.41421Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 15.0019C19.0001 14.4496 18.5524 14.0019 18.0001 14.0019C17.4478 14.0019 17.0001 14.4496 17.0001 15.0019V17H15.002C14.4497 17 14.002 17.4477 14.002 18C14.002 18.5523 14.4497 19 15.002 19H17.0001V20.9981C17.0001 21.5504 17.4478 21.9981 18.0001 21.9981C18.5524 21.9981 19.0001 21.5504 19.0001 20.9981V19H20.9982C21.5505 19 21.9982 18.5523 21.9982 18C21.9982 17.4477 21.5505 17 20.9982 17H19.0001V15.0019Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGrey);
export default __webpack_public_path__ + "static/media/file_grey.7a792b16786a1899ff258e754deabbc1.svg";
export { ForwardRef as ReactComponent };